export default __webpack_public_path__ + "static/media/noCrush.f69b109b.png";